import React, {useEffect, useState} from 'react';
import {Alert, Form, Input, Modal, Select} from 'antd';
import {createGroup, GROUP_TYPE_OPTIONS} from '../api/groupApi';

/**
 * 그룹 생성 모달
 * 대상 ID 목록은 줄바꿈/쉼표/공백 구분자로 UUID 여러 개 입력.
 */
const GroupCreateModal = ({ open, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [rawTargets, setRawTargets] = useState('');
  const [parsedCount, setParsedCount] = useState(0);

  const parseTargets = (text) => {
    if (!text) return [];
    return text
      .split(/[\n,\s]+/)
      .map(t => t.trim())
      .filter(Boolean);
  };

  useEffect(() => {
    setParsedCount(parseTargets(rawTargets).length);
  }, [rawTargets]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const ids = parseTargets(rawTargets);
      setSubmitting(true);
      await createGroup({ groupType: values.groupType, groupNm: values.groupNm, groupDsctn: values.groupDsctn, trgtIdList: ids });
      onSuccess?.();
      form.resetFields();
      setRawTargets('');
    } catch (e) {
      // validation error -> ignore, request error -> console
      if (e?.message) console.warn(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setRawTargets('');
    onCancel?.();
  };

  return (
    <Modal
      open={open}
      title="그룹 생성"
      onOk={handleOk}
      confirmLoading={submitting}
      okText="저장"
      cancelText="취소"
      onCancel={handleCancel}
      destroyOnClose
    >
      <Alert
        type="info"
        style={{ marginBottom: 16 }}
        message={
          <div>
            대상 ID(UUID) 여러 개를 공백 / 줄바꿈 / 쉼표로 구분하여 입력하세요.<br/>
            빈 목록도 허용되며, 필요 시 추후 편집 기능을 확장할 수 있습니다.
          </div>
        }
      />
      <Form layout="vertical" form={form} preserve={false}>
        <Form.Item
          label="그룹타입"
          name="groupType"
          rules={[{ required: true, message: '그룹타입을 선택하세요.' }]}
        >
          <Select
            placeholder="선택"
            options={GROUP_TYPE_OPTIONS}
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item
          label="그룹명"
          name="groupNm"
          rules={[{ required: true, message: '그룹명을 입력하세요.' }]}
        >
          <Input placeholder="그룹명" maxLength={100} />
        </Form.Item>
        <Form.Item
          label="그룹내용"
          name="groupDsctn"
          tooltip="선택 입력"
        >
          <Input.TextArea rows={3} maxLength={1000} placeholder="그룹 설명(선택)" />
        </Form.Item>
        <Form.Item label={`대상 ID 목록 (${parsedCount}개)`} name="targets" style={{ marginBottom: 4 }}>
          <Input.TextArea
            placeholder="UUID 여러 개 입력"
            rows={6}
            value={rawTargets}
            onChange={e => setRawTargets(e.target.value)}
            allowClear
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default GroupCreateModal;
